import React from 'react';
import Bank from './input/Bank';
import { Grid, Typography } from "@material-ui/core"
import Images from '../../../../../assets/images';
import useWizardFormCtx from '../../ctx-provider/useWizardFormCtx';

const FormBank: React.FC = () => {

    const { wizardFormBo } = useWizardFormCtx();
    const formAntrag = wizardFormBo.antrag;
    const textKontoinhaber = (formAntrag.vnVorname && formAntrag.vnName) ? `${formAntrag.vnVorname} ${formAntrag.vnName}` : '';


    return (
        <div>
            {/* Bankverbindung */}
            <div style={{ marginBottom: 10 }}>
                <Typography variant='h4' color='textPrimary'>Zahlungsart</Typography>
                <div style={{ marginTop: 10 }}>
                    <img src={Images.bankSepa} alt="SEPA" />
                </div>
            </div>

            <Grid container spacing={1}>
                <Grid item xs={12} md={12} container>
                    <Grid item xs={12} md={3}><Typography color='textPrimary' style={{ fontWeight: 'bold' }}>Kontoinhaber:</Typography></Grid>
                    <Grid item xs={12} md={9}><Typography color='textPrimary'>{textKontoinhaber}</Typography></Grid>
                </Grid>
                <Grid item xs={12} md={12} style={{ marginTop: 10 }}>
                    <Bank />
                </Grid>

            </Grid>
        </div>
    );
}

export default FormBank;